import { Url } from '../url';

export class WebPushServiceWorker {
    private static serviceWorkerInstance: ServiceWorkerRegistration;

    static async registerServiceWorker(): Promise<boolean> {
        try {
            const serviceWorkerUrl: string = Url.getNoLangUrl('static/j/firebase-messaging-sw.js');
            const existsServiceWorkerRegistrations = await WebPushServiceWorker.getSwRegistrations();
            if (existsServiceWorkerRegistrations) {
                this.serviceWorkerInstance = existsServiceWorkerRegistrations;
                console.log('Got exist service worker');
                return true;
            } else if (!this.serviceWorkerInstance) {
                this.serviceWorkerInstance = await navigator.serviceWorker.register(serviceWorkerUrl);
                console.log('New service worker was success installed');
                return true;
            } else {
                console.log('Service worker was exist');
                return true;
            }
        } catch (exception) {
            console.error('ServiceWorker registration fault', exception);
            window.Sentry.captureException('ServiceWorker registration fault');
            return false;
        }
    }

    static async getInstance(): Promise<ServiceWorkerRegistration> {
        if (!this.serviceWorkerInstance) {
            await this.registerServiceWorker();
        }
        return this.serviceWorkerInstance;
    }

    static async getSwRegistrations(): Promise<ServiceWorkerRegistration> {
        const swRegistrations: Array<ServiceWorkerRegistration> = await navigator.serviceWorker
            .getRegistrations() as Array<ServiceWorkerRegistration>;
        return (swRegistrations[0]) ? swRegistrations[0] : undefined;
    }

    static async checkSwUpdates(registration: ServiceWorkerRegistration = null) {
        try {
            let swInstance = registration;
            if (swInstance === null) {
                swInstance = await WebPushServiceWorker.getInstance();
            }
            console.log('FCM Leanplum try to update serviceworker');
            await swInstance.update();
            swInstance.onupdatefound = () => {
                console.log('FCM Leanplum service worker has updated');
            };
        } catch (error) {
            window.Sentry.captureException(error);
        }
    }
}
